const NumberSubLabelInput = ({ value, onChange, readOnly, fontSize }) => (
    <input
      placeholder="یک عنوان فرعی وارد کنید"
      style={{
        border: 'none',
        outline: 'none',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize,
        fontWeight: 500,
        lineHeight: 1.6,
        color: '#57647e',
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
  );
  
  export default NumberSubLabelInput;
  